import React from 'react';
import clsx from 'clsx';
import Decimal from 'decimal.js';
import { Tooltip } from '../Tooltip/Tooltip';
import { formatNumber } from '../utils/formatters';
import { Typography } from '../Typography/Typography';
import { Delimiters } from 'common-react';

import useStyles from './ProfitLossBadge.style';

export interface ProfitLossBadgeProps {
  value?: Decimal;
  className?: string;
  classes?: Partial<Record<'value' | 'suffix', string>>;
  tooltip?: { title: string; preTitle?: string };
  suffix?: string;
  variant?: 'default' | 'big';
}

export const ProfitLossBadge: React.FC<ProfitLossBadgeProps> = ({
  value,
  className,
  classes: classesProp,
  tooltip,
  suffix = 'PLN',
  variant = 'default',
}) => {
  const isProfit = !!value && value.greaterThan(0);
  const isZero = !value || value.isZero();
  const c = useStyles({ isProfit, isZero });

  if (!value) return null;
  let sign = '';
  if (!isZero) {
    sign = isProfit ? Delimiters.PLUS_SIGN : Delimiters.DASH;
  }
  const formatted = formatNumber(value.abs(), 2);

  const isBigVariant = variant === 'big';
  const badge = (
    <Typography component="span" className={clsx(c.root, className)}>
      <Typography component="span" variant={isBigVariant ? 'subHeadline2' : 'body2'} textColor='greys.80' fontWeight={isBigVariant ? 'normal' : 'bold'} className={classesProp?.value}>{sign}{formatted}</Typography>
      <Typography component="span" variant={isBigVariant ? 'subHeadline2' : 'body2'} textColor='greys.80' className={classesProp?.suffix}>&nbsp;{suffix}</Typography>
    </Typography>
  );

  if (tooltip) {
    return <Tooltip title={tooltip.title} preTitle={tooltip?.preTitle}>{badge}</Tooltip>;
  }

  return badge;
};
